export default __webpack_public_path__ + "static/media/VisitorAgreement.7bbe9468.jpg";